import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_COMMUNICATION } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolCommunicationState extends EntityState<IID_OL_COMMUNICATION, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_COMMUNICATION })
@InterfaceDataStore(InterfaceName.OLO_COMMUNICATION)
export class IIDolCommunicationStore extends EntityStore<IIDolCommunicationState> {
  constructor() {
    super([]);
  }
}
